import { defineMessages, type MessageDescriptor } from 'react-intl';

const intlMessages = {
	heroName: {
		id: 'twg-microsite.heroIcons.heroName',
		defaultMessage: 'Teamwork Graph',
		description: 'Accessible heading text for the logged-out hero wordmark.',
	},
	subtitle: {
		id: 'twg-microsite.heroIcons.subtitle',
		defaultMessage:
			'Meet the graph that automatically builds your teamwork context from everywhere you work',
		description: 'Hero supporting copy beneath the wordmark on the logged-out home page.',
	},
	previewCta: {
		id: 'twg-microsite.heroIcons.previewCta',
		defaultMessage: 'See your graph preview',
		description: 'Call-to-action label inviting the user to preview their teamwork graph.',
	},
	statusDone: {
		id: 'twg-microsite.heroIcons.statusDone',
		defaultMessage: 'Done',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusOnTrack: {
		id: 'twg-microsite.heroIcons.statusOnTrack',
		defaultMessage: 'On track',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusToDo: {
		id: 'twg-microsite.heroIcons.statusToDo',
		defaultMessage: 'To do',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusAtRisk: {
		id: 'twg-microsite.heroIcons.statusAtRisk',
		defaultMessage: 'At risk',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
} as const;

export const messages: typeof intlMessages = defineMessages(intlMessages) satisfies Record<
	string,
	MessageDescriptor
>;
